export const thinDarkScrollbar = {
  scrollbarWidth: 'thin' as const,
  scrollbarColor: '#adb5baff transparent',
  '&::-webkit-scrollbar': {
    width: 6,
    height: 6,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#5a6a75',
    borderRadius: 8,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#3E5463',
  },
};
